import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs/Observable";
import { FileUpload } from "../models/file-upload";
import { saveAs as _importedSaveAs } from "file-saver";
import { ErrorFileInfoViewModel } from "../models/ErrorFileInfoViewModel";
import { HttpClient } from "@angular/common/http";
import { EntryResponse } from "app/models/entry-response";

const URL = environment.apiBaseUrl;

@Injectable()
export class EntryService {
  constructor(private http: HttpClient) {}

  public entries(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean
  ): Observable<EntryResponse> {
    const url =
      `${URL}entries?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}`;

    return this.http.get(url).map((x: any) => {
      const res: EntryResponse = {
        entries: x.data,
        total: x.total
      };
      return res;
    });
  }

  public delete(id: number) {
    return this.http.delete(`${URL}entries/${id}`);
  }

  public importFile(fileUpload: FileUpload) {
    return this.http.post(`${URL}entries/import`, fileUpload);
  }

  public entryImporting(): Observable<boolean> {
    return this.http.get<boolean>(`${URL}entries/importRunning`);
  }

  public importReallocationFile(fileUpload: FileUpload) {
    return this.http.post(`${URL}entries/importReallocations`, fileUpload);
  }

  public reallocationEntryImporting(): Observable<boolean> {
    return this.http.get<boolean>(`${URL}entries/reallocationImportRunning`);
  }

  public downloadErrorsFile(fileName: string) {
    return this.http
      .get(`${URL}entries/errorsFile?filename=${fileName}`, {
        responseType: "blob"
      })
      .subscribe((res: any) => {
        _importedSaveAs(res, fileName);
      });
  }

  public entriesErrorsFileInfo(): Observable<ErrorFileInfoViewModel> {
    return this.http.get<ErrorFileInfoViewModel>(
      `${URL}entries/entriesErrorsFile`
    );
  }

  public closedErrorsFileInfo(): Observable<ErrorFileInfoViewModel> {
    return this.http.get<ErrorFileInfoViewModel>(
      `${URL}entries/closedErrorsFile`
    );
  }
}
